// @flow

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { css, plugins } from 'glamor';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { LinkContainer, IndexLinkContainer } from 'react-router-bootstrap';

import specific from '~/styles/plugins/specific';

plugins.add(specific);

const menu = css({
    backgroundColor: 'rgb(228, 65, 34)',
    textAlign: 'center',
    border: 0,

    '@media(min-width: 769px)': {
        height: '50px',
    },
});

const link = css({
    color: '#fff',
    backgroundColor: 'transparent',
    fontWeight: 600,
    fontSize: '1.3em',
    ':hover': {
        backgroundColor: 'transparent',
        color: '#333',
    },
    padding: 0,
    paddingLeft: '75px',
    paddingRight: '75px',
    lineHeight: '50px',

    '@media(max-width: 1200px)': {
        paddingLeft: '50px',
        paddingRight: '50px',
    },

    '@media(max-width: 992px)': {
        paddingLeft: '30px',
        paddingRight: '30px',
    },
});

const menuToggleButton = css({
    width: '40px',
    color: '#fff',
    border: 0,
    backgroundColor: 'transparent',
});

const navbar = css({
    margin: 0,

    '@media(min-width: 769px)': {
        display: 'inline-block',
    },
});

const navbarCollapse = css({
    border: 0,
    transition: 'height 0.4s ease',
    overflowY: 'hidden',
});

const brand = css({
    '@media(min-width: 769px)': {
        display: 'none',
    },
});

const logo = css({
    width: '30px',
    height: '30px',
    position: 'relative',
    top: '-3px',
});

const brandLink = css({
    listStyle: 'none',
    padding: 0,
});

@observer
export default class Header extends Component {
    @observable selectedKey = 1;

    @action handleSelect(selectedKey: number) {
        this.selectedKey = selectedKey;
    }

    render() {
        return (
            <div { ...menu }>
                <Navbar { ...navbar } { ...menu } fluid collapseOnSelect>
                    <Navbar.Header>
                        <div { ...brand } { ...brandLink }>
                            <Navbar.Brand>
                                <IndexLinkContainer to="/">
                                    <NavItem eventKey={ 1 }>
                                        <img
                                            { ...logo }
                                            src="/assets/images/logo-small-white.svg"
                                        />
                                    </NavItem>
                                </IndexLinkContainer>
                            </Navbar.Brand>
                        </div>
                        <Navbar.Toggle
                            data-toggle="collapse"
                            data-target=".navbar-collapse"
                            { ...menuToggleButton }
                        >
                            <FontAwesome name="bars" />
                        </Navbar.Toggle>
                    </Navbar.Header>
                    <Navbar.Collapse { ...navbarCollapse }>
                        <Nav onSelect={ this.handleSelect.bind(this) }>
                            <IndexLinkContainer to="/" { ...link }>
                                <NavItem eventKey={ 1 }>
                                    {'HOME'}
                                </NavItem>
                            </IndexLinkContainer>
                            <LinkContainer to="/reviews" { ...link }>
                                <NavItem eventKey={ 2 }>
                                    {'REVIEWS'}
                                </NavItem>
                            </LinkContainer>
                            <LinkContainer to="/platforms" { ...link }>
                                <NavItem eventKey={ 3 }>
                                    {'PLATFORMS'}
                                </NavItem>
                            </LinkContainer>
                            <a href="https://forum.supagemu.com" { ...link }>
                                {'FORUM'}
                            </a>
                            <LinkContainer to="/staff" { ...link }>
                                <NavItem eventKey={ 5 }>
                                    {'STAFF'}
                                </NavItem>
                            </LinkContainer>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Menu/index.js